module.exports = __webpack_public_path__ + "static/history-921411c31839e97dd3811a1ddfd38e9a.mp4";